import { render, staticRenderFns } from "./AssetsAndProducts.vue?vue&type=template&id=2f2cf962&"
import script from "./AssetsAndProducts.vue?vue&type=script&lang=js&"
export * from "./AssetsAndProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports